import { ReactNode, useMemo } from 'react';
import { twJoin } from 'tailwind-merge';

import { getSubcomponents } from '../utils/subcomponent';

export function Subcomponents({ children }: { children: ReactNode }) {
  return useMemo(() => {
    const { subcomponents, otherChildren } = getSubcomponents(children);
    const lensLegend = subcomponents.LensLegend;
    const lensSwitcher = subcomponents.LensSwitcher;
    const zoomControls = subcomponents.ZoomControls;

    return (
      <>
        <div
          className={twJoin(
            'absolute bottom-6 left-6 right-6 flex items-end align-bottom',
            lensSwitcher ? 'has-lens-switcher' : '',
          )}
        >
          <span className="flex-0">{lensSwitcher}</span>
          <span className="flex-1">{lensLegend}</span>
          <span className="flex-0">{zoomControls}</span>
        </div>
        {otherChildren}
      </>
    );
  }, [children]);
}
